import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INSTITUTION/SETTINGS/FUNDING';

export const {action: showFundingTypeModal} = createAction(`${domain}/SHOW_FUNDING_TYPE_MODAL`, type => ({type}));

export const {action: editFundingType} = createAction(`${domain}/EDIT_FUNDING_TYPE_MODAL`, id => ({id}));

export const {action: closeFundingTypeModal} = createAction(`${domain}/CLOSE_FUNDING_TYPE_MODAL`);
